import BasicLayout from '@/layouts/basic-layout'

const prefix = 'area-manage-'
export default [
  {
    path: '/base-manage/area-manage',
    redirect: {name: `${prefix}index`},
    component: BasicLayout,
    children: [
      {
        path: 'index',
        name: `${prefix}index`,
        meta: {title: '行政区域管理'},
        component: () => import('@/pages/base-manage/area-manage/index')
      },
      {
        path: 'detail-create',
        name: `${prefix}create`,
        auth: ['hidden'],
        meta: {title: '行政区域新增'},
        component: () => import('@/pages/base-manage/area-manage/detail-create')
      },
      {
        path: 'detail-edit/:id',
        name: `${prefix}edit`,
        auth: ['hidden'],
        meta: {title: '行政区域编辑'},
        component: () => import('@/pages/base-manage/area-manage/detail-edit')
      },
      {
        path: 'detail-view/:id',
        name: `${prefix}view`,
        auth: ['hidden'],
        meta: {title: '行政区域详情'},
        component: () => import('@/pages/base-manage/area-manage/detail-view')
      }
    ]
  }
]
